import {
  FaHome,
  FaUsers,
  FaBook,
  FaBullhorn,
  FaNewspaper,
  FaUserShield,
  FaSearch,
  FaBell,
  FaPenNib,
  FaChevronDown,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { getAvatarUrl, DEFAULT_AVATAR_DATA_URL, FALLBACK_AVATAR_SVG } from "../../utils/avatar";

const NAV_ITEMS = [
  { id: "dashboard", label: "Overview", icon: FaHome },
  { id: "users", label: "Users", icon: FaUsers },
  { id: "poems", label: "Poems", icon: FaBook },
  { id: "announcements", label: "Announcements", icon: FaBullhorn },
  { id: "adminposts", label: "Admin Posts", icon: FaNewspaper },
  { id: "adminmods", label: "Admins / Mods", icon: FaUserShield },
];

const TAB_LABELS = {
  dashboard: "Overview",
  users: "Users",
  poems: "Poems",
  announcements: "Announcements",
  adminposts: "Admin Posts",
  adminmods: "Admins / Mods",
};

export default function AdminShell({
  activeTab,
  onTabChange,
  user,
  children,
  headerAction,
}) {
  const pageTitle = TAB_LABELS[activeTab] || "Admin";
  const displayName = user?.name || user?.username || "Admin";
  const roleLabel =
    user?.role === "superadmin"
      ? "Superadmin"
      : user?.role === "admin"
        ? "Admin"
        : user?.role || "Admin";
  const initial = (displayName[0] || "A").toUpperCase();

  return (
    <div className="admin-shell">
      <aside className="admin-shell__sidebar" aria-label="Admin navigation">
        <Link to="/" className="admin-shell__brand" aria-label="Back to PeerPoetry home">
          <img
            src="/logo.png"
            alt=""
            className="admin-shell__brand-logo"
            width={28}
            height={28}
          />
          <span className="admin-shell__brand-name">PeerPoetry</span>
        </Link>

        <div className="admin-shell__panel-label">
          <FaUserShield aria-hidden="true" />
          <span>Admin Panel</span>
        </div>

        <nav className="admin-shell__nav">
          {NAV_ITEMS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              type="button"
              className={`admin-shell__nav-item${
                activeTab === id ? " admin-shell__nav-item--active" : ""
              }`}
              onClick={() => onTabChange(id)}
            >
              <Icon className="admin-shell__nav-icon" aria-hidden="true" />
              {label}
            </button>
          ))}
        </nav>

        <div className="admin-shell__sidebar-footer">
          <div className="admin-shell__quote-card">
            <FaPenNib className="admin-shell__quote-icon" aria-hidden="true" />
            <p>Writing is power. Manage with care.</p>
          </div>

          <div className="admin-shell__profile">
            <img
              src={getAvatarUrl(user?.avatar)}
              alt=""
              className="admin-shell__profile-avatar"
              onError={(e) => {
                e.currentTarget.src =
                  e.currentTarget.src === DEFAULT_AVATAR_DATA_URL
                    ? FALLBACK_AVATAR_SVG
                    : DEFAULT_AVATAR_DATA_URL;
              }}
            />
            <div className="admin-shell__profile-info">
              <span className="admin-shell__profile-name">{displayName}</span>
              <span className="admin-shell__profile-role">{roleLabel}</span>
            </div>
            <FaChevronDown className="admin-shell__profile-chevron" aria-hidden="true" />
          </div>

          <p className="admin-shell__copyright">
            &copy; {new Date().getFullYear()} PeerPoetry Admin
          </p>
        </div>
      </aside>

      <div className="admin-shell__body">
        <header className="admin-shell__topbar">
          <div className="admin-shell__search-wrap">
            <FaSearch className="admin-shell__search-icon" aria-hidden="true" />
            <input
              type="search"
              className="admin-shell__search"
              placeholder="Search anything..."
              aria-label="Search admin panel"
            />
            <kbd className="admin-shell__search-kbd">⌘ K</kbd>
          </div>
          <div className="admin-shell__topbar-actions">
            <button
              type="button"
              className="admin-shell__icon-btn admin-shell__icon-btn--bell"
              aria-label="Notifications"
            >
              <FaBell aria-hidden="true" />
              <span className="admin-shell__badge">8</span>
            </button>
            <div className="admin-shell__topbar-avatar" aria-hidden="true">
              {user?.avatar ? (
                <img
                  src={getAvatarUrl(user.avatar)}
                  alt=""
                  className="admin-shell__topbar-avatar-img"
                />
              ) : (
                initial
              )}
            </div>
          </div>
        </header>

        <div className="admin-shell__content">
          <div className="admin-shell__page-head">
            <div>
              <h1 className="admin-shell__page-title">{pageTitle}</h1>
              <p className="admin-shell__breadcrumb">Admin &gt; {pageTitle}</p>
            </div>
            {headerAction}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
